import { Controller } from '@hotwired/stimulus'

export default (class extends Controller {
  static targets = ['ios', 'android']

  connect() {
    this.#showRelevantAppLink()
  }

  #showRelevantAppLink() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.iosTarget.classList.remove('opacity-0')
      this.androidTarget.remove()
    } else if (/android/i.test(userAgent)) {
      this.androidTarget.classList.remove('opacity-0')
      this.iosTarget.remove()
    } else {
      this.element.remove()
    }
  }
})
